import { useMutationWithResultNotification } from 'api/mutations/useMutationWithResultNotification';
import { invitationAccept } from 'api/patients';
import {
  displayErrorArrayNotifications,
  displaySuccessNotification,
} from 'modules/Notifications';

function useInvitationAccept(invitationId: string, successFb?: () => void) {
  return useMutationWithResultNotification({
    asyncApiFunction: async (userId: string) => {
      await invitationAccept(userId, invitationId);
    },
    resetOnResult: true,
    onSuccess: () => {
      successFb && successFb();
      displaySuccessNotification('InvitationScreen.successfullyAccepted');
    },
    onErrorArray: (errors) => {
      displayErrorArrayNotifications(errors, 'InvitationScreen.errors');
    },
  });
}

export default useInvitationAccept;
